import Proxy from './Proxy';

class ReminderProxy extends Proxy {
  /**
   * The constructor for the CareplanProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/AssessmentReminders', parameters);
  }

  /**
   * Method used to add reminder using.
   *

   *
   * @returns {Promise} The result in a promise.
   */
  createReminder(data) {
    return this.submit('post', `${this.endpoint}`, data);
  }

  /**
   * Method used to fetch reminders using plan care id.
   *
  * @param {Object} data data to fetch patient details
   *
   * @returns {Promise} The result in a promise.
   */
  getReminders(data) {
    return this.submit('post', `${this.endpoint}/list/`, data);
  }
  /**
   * Method used to update reminders using reminder id.
   *
   * @returns {Promise} The result in a promise.
   */
  updateReminder(data) {
    return this.submit('post', `${this.endpoint}/${data.id}`, data);
  }
}

export default ReminderProxy;
